import React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Container,
} from "@mui/material";
import {
  HomeOutlined,
  ApartmentOutlined,
  WeekendOutlined,
  HandymanOutlined,
} from "@mui/icons-material";

const gold = "#C29D59";
const darkBg = "#111";

const services = [
  {
    icon: <HomeOutlined sx={{ fontSize: 36, color: darkBg }} />,
    title: "Residential Design",
    description:
      "Transform your home into a personalized sanctuary with our comprehensive residential design services.",
  },
  {
    icon: <ApartmentOutlined sx={{ fontSize: 36, color: darkBg }} />,
    title: "Commercial Design",
    description:
      "Create inspiring workspaces that boost productivity and reflect your brand's unique identity.",
  },
  {
    icon: <WeekendOutlined sx={{ fontSize: 36, color: darkBg }} />,
    title: "Custom Furniture",
    description:
      "Bespoke furniture pieces designed and crafted to perfectly complement your space.",
  },
  {
    icon: <HandymanOutlined sx={{ fontSize: 36, color: darkBg }} />,
    title: "Renovation",
    description:
      "Complete renovation services from planning to execution, bringing new life to existing spaces.",
  },
];

const Services = () => {
  return (
    <Container
        maxWidth={false}
        sx={{
          maxWidth: "1450px !important",
          mx: "auto",
          px: { xs: 2, md: 4 },
        }}
      >
    <Box
      component="section"
      id="services"
      sx={{
        py: { xs: 10, md: 14 },
      
        backgroundColor: darkBg,
        color: "#fff",
        textAlign: "center",
      }}
    >
      {/* Header */}
      <Typography
        variant="subtitle2"
        sx={{
          color: gold,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: 1,
          mb: 2,
        }}
      >
        Our Services
      </Typography>

      <Typography
        variant="h3"
        sx={{
          fontWeight: 700,
          mb: 2,
          fontSize:{sm:"45px",xs:"32px"}
        }}
      >
        Comprehensive Design{" "}
        <Box component="span" sx={{ color: "#C29D59" }}>
          Solutions
        </Box>
      </Typography>

      <Typography
        variant="body1"
        sx={{
          maxWidth: 700,
          mx: "auto",
          mb: 8,
          color: "rgba(255,255,255,0.7)",
          lineHeight: 1.7,
        }}
      >
        From concept to completion, we offer a full range of interior design
        services tailored to meet your unique needs and preferences.
      </Typography>

      {/* Service Cards */}
      <Grid
        container
        spacing={4}
        justifyContent="center"
        sx={{ mx: "auto" }}
      >
        {services.map((service) => (
          <Grid item xs={12} sm={6} md={3} key={service.title}>
            <Card
              sx={{
                height: "100%",
                width:"320px",
                backgroundColor: "transparent",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: 3,
                transition: "all 0.3s ease",
                "&:hover": {
                  borderColor: gold,
                  transform: "translateY(-6px)",
                },
              }}
            >
              <CardContent sx={{ p: 4, textAlign: "left" }}>
                {/* Icon Box */}
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: 2,
                    backgroundColor: gold,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 3,
                  }}
                >
                  {service.icon}
                </Box>

                {/* Title */}
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    mb: 1.5,
                    color: "#fff",
                  }}
                >
                  {service.title}
                </Typography>

                {/* Description */}
                <Typography
                  variant="body2"
                  sx={{
                    color: "rgba(255,255,255,0.7)",
                    lineHeight: 1.7,
                  }}
                >
                  {service.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
    </Container>
  );
};

export default Services;
